/* Boa Sem Base! · Trade-in i85 (assets/tin-boa-sem-base.js) */
(function () {
  'use strict';
  // funciona com o script antes ou depois do conteúdo (ex.: partes coladas em outra ordem)
  function boot() {
    var root = document.getElementById('lp-boa-sem-base');
    if (!root || root.getAttribute('data-bsb-ready')) return;
    root.setAttribute('data-bsb-ready', '1');
    root.classList.add('bsb-js');

    /* ================= CONFIGURAÇÃO ================= */
    // valores definidos no editor de temas (seção "Boa Sem Base! · Trade-in i85")
    var ds = root.dataset || {};
    var CONFIG = {
      // CloudPage do Marketing Cloud que grava o lead na DE. Vazio = não envia ao Marketing Cloud.
      marketingCloudUrl: ds.mcUrl || '',
      // true = envia também pelo formulário de contato nativo da Shopify (e-mail de contato da loja).
      shopifyContato: ds.shopifyContato !== '0',
      // WhatsApp do comercial, só números com DDI e DDD. Vazio = não mostra o link.
      whatsapp: ds.whatsapp || '',
      privacidadeUrl: '/policies/privacy-policy',
      campanha: ds.campanha || 'boa-sem-base-q4-2026'
    };
    /* ================================================ */

    var PREVIEW = window.BSB_PREVIEW === true;
    // arquivo aberto do computador: formulário em modo demonstração (não envia nada)
    var DEMO = PREVIEW || window.location.protocol === 'file:';
    // página servida pelo Shopify: o formulário de contato nativo (/contact) está disponível
    var ON_SHOPIFY = !!window.Shopify || !!document.querySelector('script[src*="cdn.shopify.com"],link[href*="cdn.shopify.com"],meta[name="shopify-checkout-api-token"],meta[name="shopify-digital-wallet"]');
    if (DEMO && !PREVIEW && window.console) console.info('[LP Boa Sem Base] Arquivo aberto localmente: o formulário roda em modo demonstração e não envia dados.');

    var mm = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
    var reduceMotion = mm('(prefers-reduced-motion: reduce)').matches;
    var finePointer = mm('(hover: hover) and (pointer: fine)').matches;
    var mqDesk = mm('(min-width: 1024px)');
    var hasIO = 'IntersectionObserver' in window;
    function qs(s, el) { return (el || root).querySelector(s); }
    function qsa(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
    function sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
    function sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
    function sdel(k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }

    qsa('[data-bsb-privacidade]').forEach(function (a) { a.href = CONFIG.privacidadeUrl; });

    /* largura total da tela, mesmo dentro de um contêiner do tema */
    function setVW() { root.style.setProperty('--bsb-vw', document.documentElement.clientWidth + 'px'); }
    setVW();

    /* UTMs: lidas da URL e guardadas na sessão */
    var params = new URLSearchParams(window.location.search);
    var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
    var utm = {};
    UTM_KEYS.forEach(function (k) { var v = params.get(k); if (v) utm[k] = v.slice(0, 200); });
    if (Object.keys(utm).length) sset('bsb_utm', JSON.stringify(utm));
    else { try { utm = JSON.parse(sget('bsb_utm') || '{}') || {}; } catch (e) { utm = {}; } }

    /* ---------- hero: entrada, parallax e sinal do satélite ---------- */
    var hero = qs('.bsb-hero');
    var heroBg = qs('.bsb-hero__bg');
    var heroImg = qs('.bsb-product img');
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { hero.classList.add('is-ready'); }); });
    if (!reduceMotion) window.setTimeout(function () {
      var c = qs('.bsb-hero .bsb-cta');
      if (!c) return;
      c.classList.add('is-shine');
      window.setTimeout(function () { c.classList.remove('is-shine'); }, 1200);
    }, 2300);

    if (finePointer && !reduceMotion) {
      var pRaf = 0, pX = 0, pY = 0;
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        pX = ((e.clientX - r.left) / r.width - 0.5) * 2;
        pY = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!pRaf) pRaf = window.requestAnimationFrame(function () {
          pRaf = 0;
          hero.style.setProperty('--px', pX.toFixed(3));
          hero.style.setProperty('--py', pY.toFixed(3));
        });
      });
      hero.addEventListener('pointerleave', function () { hero.style.setProperty('--px', '0'); hero.style.setProperty('--py', '0'); });
    }

    var signal = qs('.bsb-signal');
    var sigPath = qs('.bsb-signal__path');
    function placeSignal() {
      if (!signal || !mqDesk.matches) return;
      var h = hero.getBoundingClientRect(), b = heroBg.getBoundingClientRect(), p = heroImg.getBoundingClientRect();
      if (!b.width || !p.width) return;
      var sx = b.left - h.left + b.width * 0.31, sy = b.top - h.top + b.height * 0.5;
      var rx = p.left - h.left + p.width * 0.405, ry = p.top - h.top + p.height * 0.012;
      var cx = (sx + rx) / 2, cy = Math.min(sy, ry) - Math.max(80, (rx - sx) * 0.16);
      signal.setAttribute('viewBox', '0 0 ' + Math.round(h.width) + ' ' + Math.round(h.height));
      sigPath.setAttribute('d', 'M' + sx.toFixed(1) + ' ' + sy.toFixed(1) + ' Q' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ' ' + rx.toFixed(1) + ' ' + ry.toFixed(1));
    }
    placeSignal();
    window.addEventListener('load', placeSignal);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeSignal);
    if (heroImg && !heroImg.complete) heroImg.addEventListener('load', placeSignal);
    var rsT = 0;
    window.addEventListener('resize', function () {
      setVW();
      window.clearTimeout(rsT);
      rsT = window.setTimeout(placeSignal, 150);
    }, { passive: true });

    /* ---------- entrada por rolagem ---------- */
    var revealEls = qsa('[data-reveal],[data-reveal-line]');
    if (!hasIO || reduceMotion) revealEls.forEach(function (el) { el.classList.add('is-in'); });
    else {
      var rio = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); rio.unobserve(x.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      revealEls.forEach(function (el) { rio.observe(el); });
    }

    /* ---------- animações contínuas pausadas fora da tela ---------- */
    if (hasIO && !reduceMotion) {
      var sio = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          x.target.classList.toggle('is-off', !x.isIntersecting);
          if (x.target === hero && signal && signal.pauseAnimations) {
            try { if (x.isIntersecting) signal.unpauseAnimations(); else signal.pauseAnimations(); } catch (e) {}
          }
        });
      }, { rootMargin: '120px 0px' });
      qsa('section').forEach(function (sec) { sio.observe(sec); });
    }
    var ribbon = qs('[data-bsb-ribbon]');
    if (ribbon) ribbon.addEventListener('click', function () { ribbon.classList.toggle('is-paused'); });

    /* ---------- números que contam ---------- */
    function fmt(v, dec) { return v.toFixed(dec).replace('.', ','); }
    if (hasIO && !reduceMotion) {
      var counters = qsa('[data-bsb-count]');
      counters.forEach(function (el) { el.textContent = fmt(0, parseInt(el.getAttribute('data-dec') || '0', 10)); });
      var cio = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting) return;
          cio.unobserve(x.target);
          var el = x.target, to = parseFloat(el.getAttribute('data-bsb-count')), dec = parseInt(el.getAttribute('data-dec') || '0', 10), t0 = 0;
          var step = function (t) {
            if (!t0) t0 = t;
            var k = Math.min(1, (t - t0) / 1400);
            k = 1 - Math.pow(1 - k, 3);
            el.textContent = fmt(to * k, dec);
            if (k < 1) window.requestAnimationFrame(step);
          };
          window.requestAnimationFrame(step);
        });
      }, { threshold: 0.6 });
      counters.forEach(function (el) { cio.observe(el); });
    }

    /* ---------- rolagem até o formulário ---------- */
    var formSec = qs('#troca');
    var formTitle = qs('#bsb-form-titulo');
    function goToForm(e, target) {
      if (e) e.preventDefault();
      formSec.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      window.setTimeout(function () {
        if (target && finePointer) {
          try { target.focus({ preventScroll: true }); var L = target.value.length; target.setSelectionRange(L, L); } catch (err) {}
        } else {
          try { formTitle.focus({ preventScroll: true }); } catch (err) {}
        }
        if (target) { target.classList.remove('is-flash'); void target.offsetWidth; target.classList.add('is-flash'); }
      }, reduceMotion ? 0 : 650);
    }
    qsa('a[href="#troca"]:not([data-bsb-check-go])').forEach(function (a) { a.addEventListener('click', function (e) { goToForm(e); }); });

    /* ---------- checklist: o receptor está apto para a troca? ---------- */
    var checks = qsa('[data-bsb-check]');
    var checkSt = qs('[data-bsb-check-st]');
    var checkOk = qs('[data-bsb-check-ok]');
    var checkGo = qs('[data-bsb-check-go]');
    var checkTimer = 0;
    function checklistTexto() {
      if (!checks.some(function (c) { return c.checked; })) return 'não respondido';
      return checks.map(function (c) { return c.getAttribute('data-bsb-check') + ': ' + (c.checked ? 'sim' : 'não marcado'); }).join(' | ');
    }
    function updateChecklist(fromUser) {
      var n = checks.filter(function (c) { return c.checked; }).length;
      var done = n === checks.length;
      checks.forEach(function (c) { c.parentNode.classList.toggle('is-on', c.checked); });
      window.clearTimeout(checkTimer);
      checkOk.hidden = !done;
      checkSt.classList.toggle('bsb-sr', done);
      checkSt.textContent = done ? 'Parabéns! Seu receptor está apto para a troca. Levando você ao formulário.' : n + ' de ' + checks.length + ' marcadas.';
      // as duas marcadas: parabéns e, em seguida, o formulário
      if (done && fromUser) checkTimer = window.setTimeout(function () { goToForm(null, qs('#bsb-nome')); }, 2400);
    }
    if (checks.length && checkSt && checkOk) {
      checks.forEach(function (c) { c.addEventListener('change', function () { updateChecklist(true); }); });
      updateChecklist(false);
      if (checkGo) checkGo.addEventListener('click', function (e) { window.clearTimeout(checkTimer); goToForm(e, qs('#bsb-nome')); });
    }

    /* ---------- PointX: base própria x PointX ---------- */
    var px = qs('.bsb-px');
    if (px) {
      var modeBtns = qsa('[data-bsb-mode]', px);
      var cap = qs('[data-bsb-cap]', px);
      var lBase = qs('.bsb-cmp--base', px), lPx = qs('.bsb-cmp--pointx', px);
      var CAPS = {
        base: 'Com base própria, você leva, monta e vigia a base, que envia a correção ao rover por rádio.',
        pointx: 'Com PointX, a correção chega ao i85 por satélite* ou pela internet, sem base própria.'
      };
      var touched = false;
      var setMode = function (m) {
        px.setAttribute('data-mode', m);
        modeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-bsb-mode') === m ? 'true' : 'false'); });
        lBase.setAttribute('aria-hidden', m === 'base' ? 'false' : 'true');
        lPx.setAttribute('aria-hidden', m === 'pointx' ? 'false' : 'true');
        cap.textContent = CAPS[m];
      };
      modeBtns.forEach(function (b) { b.addEventListener('click', function () { touched = true; cap.setAttribute('aria-live', 'polite'); setMode(b.getAttribute('data-bsb-mode')); }); });
      if (hasIO && !reduceMotion) {
        var dio = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting || touched) return;
          dio.disconnect();
          setMode('base');
          window.setTimeout(function () { if (!touched) setMode('pointx'); }, 2400);
        }, { threshold: 0.5 });
        dio.observe(qs('.bsb-px__scene', px));
      }
    }

    /* ---------- i85: pontos interativos ---------- */
    var featBtns = qsa('[data-bsb-feat]');
    var featPanels = qsa('.bsb-feat__p');
    var featBox = qs('[data-bsb-panels]');
    var featIdx = 0, featTimer = 0, featTouched = false;
    function setFeat(i) {
      featIdx = i;
      featBtns.forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-bsb-feat') === i ? 'true' : 'false'); });
      featPanels.forEach(function (p) { p.classList.toggle('is-on', +p.getAttribute('data-p') === i); });
    }
    function stopCycle() { if (featTimer) { window.clearInterval(featTimer); featTimer = 0; } }
    featBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        featTouched = true;
        stopCycle();
        if (featBox) featBox.setAttribute('aria-live', 'polite');
        setFeat(+b.getAttribute('data-bsb-feat'));
      });
    });
    var featGrid = qs('.bsb-i85__grid');
    if (featGrid && featPanels.length && hasIO && !reduceMotion) {
      ['pointerenter', 'focusin'].forEach(function (ev) { featGrid.addEventListener(ev, function () { featTouched = true; stopCycle(); }); });
      new IntersectionObserver(function (en) {
        var vis = en[0].isIntersecting;
        if (vis && !featTouched && !featTimer) featTimer = window.setInterval(function () {
          var n = (featIdx + 1) % featPanels.length;
          setFeat(n);
          if (n === 0) { featTouched = true; stopCycle(); } // uma volta completa e para
        }, 4200);
        if (!vis) stopCycle();
      }, { threshold: 0.45 }).observe(featGrid);
    }

    /* ---------- cards do kit com inclinação ---------- */
    if (finePointer && !reduceMotion) {
      qsa('.bsb-card').forEach(function (c) {
        c.addEventListener('pointermove', function (e) {
          var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          c.classList.add('is-tilt');
          c.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * 8).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 10).toFixed(2) + 'deg) translateY(-4px)';
          c.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
          c.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
        });
        c.addEventListener('pointerleave', function () { c.classList.remove('is-tilt'); c.style.transform = ''; });
      });
    }

    /* ---------- acordeões com abertura suave ---------- */
    qsa('details[data-bsb-acc]').forEach(function (d) {
      var s = d.querySelector('summary'), body = d.querySelector('[data-bsb-acc-body]');
      s.addEventListener('click', function (e) {
        if (reduceMotion || !body || !body.animate) return;
        e.preventDefault();
        if (d.getAttribute('data-anim')) return;
        d.setAttribute('data-anim', '1');
        var pb = window.getComputedStyle(body).paddingBottom;
        if (d.open) {
          var h = body.offsetHeight;
          var a = body.animate([{ height: h + 'px', paddingBottom: pb, opacity: 1 }, { height: '0px', paddingBottom: '0px', opacity: 0 }], { duration: 260, easing: 'ease' });
          a.onfinish = function () { d.open = false; d.removeAttribute('data-anim'); };
        } else {
          d.open = true;
          var h2 = body.offsetHeight;
          var a2 = body.animate([{ height: '0px', paddingBottom: '0px', opacity: 0 }, { height: h2 + 'px', paddingBottom: pb, opacity: 1 }], { duration: 320, easing: 'ease' });
          a2.onfinish = function () { d.removeAttribute('data-anim'); };
        }
      });
    });

    /* ---------- botão fixo no celular ---------- */
    var sticky = qs('[data-bsb-sticky]');
    var heroCta = qs('[data-bsb-cta]');
    var foot = qs('.bsb-foot');
    if (sticky && hasIO) {
      var st = { heroGone: false, form: false, foot: false };
      var paint = function () { sticky.classList.toggle('is-on', st.heroGone && !st.form && !st.foot); };
      new IntersectionObserver(function (en) { en.forEach(function (x) { st.heroGone = !x.isIntersecting && x.boundingClientRect.top < 0; }); paint(); }).observe(heroCta);
      new IntersectionObserver(function (en) { en.forEach(function (x) { st.form = x.isIntersecting; }); paint(); }, { rootMargin: '0px 0px -10% 0px' }).observe(formSec);
      new IntersectionObserver(function (en) { en.forEach(function (x) { st.foot = x.isIntersecting; }); paint(); }).observe(foot);
    }

    /* ---------- formulário ---------- */
    var form = qs('#bsb-form');
    form.setAttribute('novalidate', '');
    var area = qs('[data-bsb-form-area]');
    var success = qs('#bsb-sucesso');
    var statusEl = qs('[data-bsb-status]');
    var submitBtn = qs('[data-bsb-submit]');
    var submitLabel = qs('[data-bsb-submit-label]');
    var waLink = qs('[data-bsb-wa]');
    var nome = qs('#bsb-nome');
    var email = qs('#bsb-email');
    var tel = qs('#bsb-tel');
    var LABEL = submitLabel.textContent;

    if (CONFIG.whatsapp) {
      waLink.href = 'https://wa.me/' + CONFIG.whatsapp.replace(/\D+/g, '') + '?text=' + encodeURIComponent('Olá! Quero saber minha condição na troca pelo RTK i85 (Promoção Boa Sem Base!).');
      waLink.target = '_blank';
      waLink.rel = 'noopener';
      waLink.hidden = false;
    }

    function digits(s) { return String(s || '').replace(/\D+/g, ''); }
    function fmtPhone(d) {
      d = d.slice(0, 11);
      if (!d.length) return '';
      if (d.length <= 2) return '(' + d;
      if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
      if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
      return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
    }
    tel.addEventListener('keydown', function (e) {
      if (e.key !== 'Backspace' || tel.selectionStart !== tel.selectionEnd) return;
      var p = tel.selectionStart;
      while (p > 0 && /\D/.test(tel.value.charAt(p - 1))) p--;
      if (p !== tel.selectionStart) tel.setSelectionRange(p, p);
    });
    tel.addEventListener('input', function () {
      var caret = tel.selectionStart || 0;
      var before = digits(tel.value.slice(0, caret)).length;
      var d = digits(tel.value);
      var cut = 0;
      if (d.length > 11 && d.slice(0, 2) === '55') { d = d.slice(2); cut = 2; } // +55 colado ou preenchido
      while (d.charAt(0) === '0') { d = d.slice(1); cut++; }                   // 0 de longa distância
      var out = fmtPhone(d);
      tel.value = out;
      before = Math.max(0, before - cut);
      var pos = 0, seen = 0;
      while (pos < out.length && seen < before) { if (/\d/.test(out.charAt(pos))) seen++; pos++; }
      if (cut) pos = out.length;
      try { tel.setSelectionRange(pos, pos); } catch (e) {}
      if (tel.getAttribute('aria-invalid') === 'true') check(tel);
    });

    var RULES = {
      'bsb-nome': function (v) { return v.trim().length >= 2 ? '' : 'Informe seu nome.'; },
      'bsb-email': function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()) ? '' : 'Informe um e-mail válido.'; },
      'bsb-tel': function (v) { var d = digits(v); return (d.length === 10 || d.length === 11) && d.charAt(0) !== '0' ? '' : 'Informe um telefone com DDD.'; }
    };
    function check(input) {
      var msg = RULES[input.id](input.value);
      var err = qs('#' + input.id + '-err');
      input.setAttribute('aria-invalid', msg ? 'true' : 'false');
      err.textContent = msg;
      err.hidden = !msg;
      return !msg;
    }
    [nome, email, tel].forEach(function (input) {
      input.addEventListener('blur', function () { if (input.value) check(input); });
      input.addEventListener('input', function () { if (input !== tel && input.getAttribute('aria-invalid') === 'true') check(input); });
    });

    function origemTexto() {
      var parts = [];
      Object.keys(utm).forEach(function (k) { parts.push(k + '=' + utm[k]); });
      return parts.join(' | ') || 'direto';
    }
    function setBusy(on) {
      submitBtn.disabled = on;
      submitLabel.textContent = on ? 'ENVIANDO…' : LABEL;
    }
    function showError() {
      statusEl.innerHTML = '';
      statusEl.appendChild(document.createTextNode('Não foi possível enviar agora. Tente de novo em instantes.'));
      if (CONFIG.whatsapp) {
        statusEl.appendChild(document.createTextNode(' Se preferir, '));
        var a = document.createElement('a');
        a.className = 'bsb-link'; a.href = waLink.href; a.target = '_blank'; a.rel = 'noopener';
        a.textContent = 'fale com a gente pelo WhatsApp';
        statusEl.appendChild(a);
        statusEl.appendChild(document.createTextNode('.'));
      }
      statusEl.hidden = false;
    }
    function showSuccess(focus) {
      area.hidden = true;
      success.hidden = false;
      if (focus) { try { success.focus({ preventScroll: true }); } catch (e) {} }
    }
    function track() {
      var info = { form_id: 'bsb-troca', campaign: CONFIG.campanha };
      try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', info); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'generate_lead', form_id: info.form_id, campaign: info.campaign }); } catch (e) {}
      try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: info.campaign }); } catch (e) {}
      try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish('bsb_generate_lead', info); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('bsb:lead', { detail: info })); } catch (e) {}
    }
    function sendToMarketingCloud(data) {
      if (!CONFIG.marketingCloudUrl) return false;
      var body = new URLSearchParams(data);
      try { if (navigator.sendBeacon && navigator.sendBeacon(CONFIG.marketingCloudUrl, body)) return true; } catch (e) {}
      try { fetch(CONFIG.marketingCloudUrl, { method: 'POST', mode: 'no-cors', keepalive: true, body: body }); return true; } catch (e) { return false; }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      statusEl.hidden = true;
      if (form.elements.bsb_site && form.elements.bsb_site.value) return; // robô
      var ok = [nome, email, tel].map(check);
      var firstBad = [nome, email, tel].filter(function (x, i) { return !ok[i]; })[0];
      if (firstBad) { firstBad.focus(); return; }

      var dados = {
        nome: nome.value.trim(),
        email: email.value.trim(),
        telefone: tel.value.trim(),
        checklist: checklistTexto(),
        campanha: CONFIG.campanha,
        pagina: window.location.href.split('#')[0],
        data_envio: new Date().toISOString(),
        consentimento: '1'
      };
      UTM_KEYS.forEach(function (k) { dados[k] = utm[k] || ''; });

      qs('[data-bsb-origem]').value = origemTexto();
      qs('[data-bsb-pagina]').value = dados.pagina;
      qs('[data-bsb-checklist]').value = dados.checklist;
      qs('[data-bsb-body]').value =
        'Lead da LP Promoção Boa Sem Base! (troca pelo RTK i85)\n' +
        'Checklist de aptidão: ' + dados.checklist + '\n' +
        'Origem: ' + origemTexto();

      setBusy(true);
      if (DEMO) {
        sset('bsb_pendente', '1');
        window.location.href = window.location.pathname + '?contact_posted=true#troca';
        return;
      }
      var mcSent = sendToMarketingCloud(dados);

      if (CONFIG.shopifyContato && ON_SHOPIFY) {
        sset('bsb_pendente', '1');
        form.submit();
        return;
      }
      if (mcSent) { showSuccess(true); track(); setBusy(false); return; }
      if (window.console) console.warn('[LP Boa Sem Base] Nenhum destino de envio: fora do Shopify, preencha CONFIG.marketingCloudUrl.');
      setBusy(false);
      showError();
    });

    /* voltar pelo navegador (cache da página) não deixa o botão travado em "Enviando…" */
    window.addEventListener('pageshow', function (e) { if (e.persisted) setBusy(false); });

    /* volta do envio pelo Shopify */
    var pendente = sget('bsb_pendente');
    if (params.get('contact_posted') === 'true') {
      showSuccess(false);
      if (pendente) { sdel('bsb_pendente'); track(); }
      window.setTimeout(function () {
        formSec.scrollIntoView({ block: 'start' });
        try { success.focus({ preventScroll: true }); } catch (e) {}
      }, 60);
    } else if (pendente) {
      sdel('bsb_pendente');
      showError();
    }
    root.setAttribute('data-bsb-ok', '1');
  }
  if (document.getElementById('lp-boa-sem-base') || document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
